import { getAuthenticated } from '../../../../services/RestTemplate';
import { objToUrlParams } from '../../../../shared/helpers/url-params.helper';

const statsApi = '/stats/';

export function getStats() {
    return getAuthenticated(statsApi);
}

export function getWorldmap(args) {
    const urlParams = objToUrlParams(args);
    return getAuthenticated(statsApi + 'worldmap' + urlParams);
}

export function getNumberOfPlayers(args) {
    const urlParams = objToUrlParams(args);
    return getAuthenticated(statsApi + 'numberOfPlayers' + urlParams);
}

export function getNumberOfPlayersWithOpenAlerts(args) {
    const urlParams = objToUrlParams(args);
    return getAuthenticated(
        statsApi + 'numberOfPlayersWithOpenAlerts' + urlParams
    );
}

export function getNumberOfActivePlayers(args) {
    const urlParams = objToUrlParams(args);
    return getAuthenticated(statsApi + 'numberOfActivePlayers' + urlParams);
}

export function getNumberOfEventsForTheLastDay(args) {
    const urlParams = objToUrlParams(args);
    return getAuthenticated(
        statsApi + 'numberOfEventsForTheLastDay' + urlParams
    );
}

export function getTopRiskyPlayers(args) {
    const urlParams = objToUrlParams(args);
    return getAuthenticated(statsApi + 'topRiskyPlayers' + urlParams);
}
export function getRegistrationsPerMonth(args) {
    const urlParams = objToUrlParams(args);
    return getAuthenticated(statsApi + 'registrationsPerMonth' + urlParams);
}
export function getOverallSystemRisk(args) {
    const urlParams = objToUrlParams(args);
    return getAuthenticated(statsApi + 'overallSystemRisk' + urlParams);
}
export function getOpenAlertsPerRuleCategory(args) {
    const urlParams = objToUrlParams(args);
    return getAuthenticated(statsApi + 'openAlertsPerRuleCategory' + urlParams);
}

//
// worldmap
// numberOfPlayers
// numberOfPlayersWithOpenAlerts?brandId=1&jurisdiction=MT
// numberOfActivePlayers?brandId=1&jurisdiction=MT
// numberOfEventsForTheLastDay?brandId=1&jurisdiction=MT&eventType=BET
// numberOfEventsForTheLastDay?brandId=1&jurisdiction=MT&eventType=DEPOSIT
// topRiskyPlayers
// registrationsPerMonth
// overallSystemRisk
// openAlertsPerRuleCategory?brandId=1&jurisdiction=MT

// numberOfActivePlayers
// numberOfEventsForTheLastDay
// numberOfEventsForTheLastDay
// topRiskyPlayers
// registrationsPerMonth
// overallSystemRisk
// openAlertsPerRuleCategory
